/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Final_Cta_PrimaryInputs */

const en_mk_final_cta_primary = /** @type {(inputs: Mk_Final_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try free for 14 days`)
};

const id_mk_final_cta_primary = /** @type {(inputs: Mk_Final_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba gratis 14 hari`)
};

/**
* | output |
* | --- |
* | "Try free for 14 days" |
*
* @param {Mk_Final_Cta_PrimaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_final_cta_primary = /** @type {((inputs?: Mk_Final_Cta_PrimaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Final_Cta_PrimaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_final_cta_primary(inputs)
	return en_mk_final_cta_primary(inputs)
});